module.exports = __webpack_public_path__ + "static/img/img-seal.45eefd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-seal.png
// module id = 154
// module chunks = 2